import React, { Component } from 'react';
import { withAlert } from 'react-alert';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as registerActions from './actions/';
import Cookies from 'universal-cookie';
import Helper from '../../helpers/index';
import IframePopup from '../../components/IframePopup';

const cookies = new Cookies();
const translate = trKey => window.VULOG_TRANSLATE(trKey);
class GdprScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            iframeLink: null,
        };
    }

    componentDidMount() {
        this.props.setStep(-1);
    }

    accept() {
        cookies.set('gdpr', true);
        window.location.reload();
    }

    cancel() {
        const cancelUrl =
            (window.VULOG_CONFIG.CANCEL_URL &&
                window.VULOG_CONFIG.CANCEL_URL.replace(
                    '{message}',
                    window.encodeURIComponent(window.VULOG_TRANSLATE('CANCEL_URL_MESSAGE'))
                ).replace('{title}', window.encodeURIComponent(window.VULOG_TRANSLATE('CANCEL_URL_TITLE')))) ||
            '#';
        document.location = cancelUrl;
    }

    createIframePopup = iframeLink => {
        return e => {
            this.setState({
                iframeLink,
            });
        };
    };

    generateLegalNotice() {
        const legalLink = window.VULOG_CONFIG.LEGAL_LINK;
        if (legalLink.indexOf('.pdf') > -1) {
            if (!this.props.isApps) {
                return (
                    <a href={legalLink} target="_blank" rel="noopener noreferrer">
                        {window.VULOG_TRANSLATE('Legal Notice')}
                    </a>
                );
            }
            return (
                <a href={`newtab:${legalLink}`} download="terms-of-service">
                    {window.VULOG_TRANSLATE('Legal Notice')}
                </a>
            );
        }
        return (
            <a onClick={this.createIframePopup(legalLink)} href={'#/'}>
                {translate('Legal Notice')}
            </a>
        );
    }

    render() {
        return (
            <div className="container-fluid d-flex flex-column full-height menu-bar-bottom gdpr-screen">
                <div className="gdpr-container">
                    <h3 className="mb-0">{translate('GDPR_PAGE_TITLE')}</h3>
                    <h4 className="mb-0">{translate('GDPR_PAGE_SUBTITLE')}</h4>

                    <div className="gdpr-content">{Helper.generateGdprText(this.props.isApps)}</div>

                    <div className="d-flex flex-row flex-wrap btn-container">
                        <button
                            className="btn btn-primary white btn-block full ml-auto mr-auto"
                            onClick={this.accept.bind(this)}
                        >
                            <strong>{translate('Accept')}</strong> <br />{' '}
                            {translate('I confirm i am over 16 years old')}
                        </button>
                        <button
                            className="btn btn-primary btn-block full ml-auto mr-auto"
                            onClick={this.cancel.bind(this)}
                        >
                            {translate('Cancel')}
                        </button>
                    </div>

                    <ul className="gdpr-links">
                        <li>{this.generateLegalNotice()}</li>
                    </ul>
                </div>
                <IframePopup
                    link={this.state.iframeLink}
                    onClose={() => this.setState({ iframeLink: null })}
                    isOpen={this.state.iframeLink}
                />
            </div>
        );
    }
}

function mapStateToProps() {
    return {};
}
/**
 * Get actions and pass them as props to Component
 * @param dispatch
 * @returns {{}|B|N}
 */

function mapDispatchToProps(dispatch) {
    return bindActionCreators(registerActions, dispatch);
}

export default withAlert(connect(mapStateToProps, mapDispatchToProps)(GdprScreen));
